export class Busy {

  private internalBusy: number = 0;

  public SetBusy() {
    this.internalBusy = this.internalBusy++;
  }

  public SetFree() {
    if (this.internalBusy > 0) {
      this.internalBusy = this.internalBusy--;
    }
  }

  public get isBusy() {
    return this.internalBusy > 0;
  }

}
